import { mount } from './utils';

class ComponentPopper {
  constructor(elementId = 'component-popper-wrapper') {
    this.el = document.getElementById(elementId);
    this.$$components = [];
  }

  show(component, props, options) {
    const index = this.$$components.length;
    const { promise, close } = mount(this.getElement(), component, props, options);
    this.$$components.push({ promise, index, close });

    return { promise, index };
  }

  getElement() {
    const el = document.createElement('div');
    this.el.appendChild(el);
    return el;
  }

  close(index) {
    const comp = this.$$components[index];
    if (!comp) {
      return;
    }
    this.$$components[index] = null;
    comp.close();

    if (!this.$$components.some(Boolean)) {
      this.$$components = [];
    }
  }
}

export default new ComponentPopper();
